// Bileli · modules/media/lib — persisted bind targets (the link-before-bytes retry net). why: the bind
// mutation fires immediately at ticket time; if it never lands (reload / nav / network) the global link
// driver retries it from here. Backend binds are idempotent, so re-writing the same mediaId is a no-op.

import type { MediaKind } from '../model/media.types';

import { lsRead, lsSubscribe, lsWrite, MEDIA_TTL_MS } from './lsUtil';

const KEY = 'bileli:pending-media-links';
const EVENT = 'bileli:pending-media-links:changed';

export type PendingLinkTarget =
  | { type: 'course-cover'; courseId: string }
  | { type: 'course-preview'; courseId: string }
  | { type: 'lesson-content'; lessonId: string; field: 'videoMediaId' | 'pdfMediaId' };

export interface PendingLinkEntry {
  id: string;
  assetId: string;
  kind: MediaKind;
  target: PendingLinkTarget;
  createdAt: number;
}

export function listPendingLinks(now = Date.now()): PendingLinkEntry[] {
  const all = lsRead<PendingLinkEntry[]>(KEY) ?? [];
  const fresh = all.filter((e) => e && e.assetId && e.target && now - e.createdAt < MEDIA_TTL_MS);
  if (fresh.length !== all.length) lsWrite(KEY, fresh, EVENT);
  return fresh;
}

export function savePendingLink(draft: Omit<PendingLinkEntry, 'id' | 'createdAt'>): PendingLinkEntry {
  const entry: PendingLinkEntry = { ...draft, id: crypto.randomUUID(), createdAt: Date.now() };
  lsWrite(KEY, [...listPendingLinks(), entry], EVENT);
  return entry;
}

export function clearPendingLinkByAssetId(assetId: string): void {
  lsWrite(KEY, listPendingLinks().filter((e) => e.assetId !== assetId), EVENT);
}

export function subscribePendingLinks(listener: () => void): () => void {
  return lsSubscribe(KEY, EVENT, listener);
}
